import type { MockLandingPlan, MockTestimonial, TestimonialFormData } from '../types/landing.types';
import type { PlanFormData } from '../../../system/types/system.types';

export const MOCK_LANDING_PLANS: MockLandingPlan[] = [
	{
		_id: '1',
		name: 'Premium',
		tipo: 'Consultor',
		cliques: 3423,
		vendas: 456,
		conversao: '13,32%',
		abandono: 433,
		status: 'active',
	},
	{
		_id: '2',
		name: 'Professional',
		tipo: 'Consultor',
		cliques: 5534,
		vendas: 647,
		conversao: '11,69%',
		abandono: 345,
		status: 'active',
	},
	{
		_id: '3',
		name: 'Basic',
		tipo: 'Gestor',
		cliques: 7535,
		vendas: 846,
		conversao: '11,23%',
		abandono: 645,
		status: 'active',
	},
	{
		_id: '4',
		name: 'Simple',
		tipo: 'Agricultor',
		cliques: 0,
		vendas: 0,
		conversao: '0%',
		abandono: 0,
		status: 'inactive',
	},
	{
		_id: '5',
		name: 'Teste',
		tipo: 'Consultor',
		cliques: 0,
		vendas: 0,
		conversao: '0%',
		abandono: 0,
		status: 'inactive',
	},
];

export const MOCK_TESTIMONIALS: MockTestimonial[] = [
	{
		_id: '1',
		name: 'Camilla Silva',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultora Agrônoma',
		testimonial: 'O Practium revolucionou minha forma de trabalhar no campo.',
		avatarUrl: '/images/mariaAbreu.png',
	},
	{
		_id: '2',
		name: 'José Ribeiro',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor Técnico',
		testimonial: 'Ferramenta indispensável para qualquer profissional do agronegócio.',
		avatarUrl: '/images/joaoMuller.png',
	},
	{
		_id: '3',
		name: 'Arthur Carvalho',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor de Produção',
		testimonial: 'Simplifiquei toda a gestão das minhas propriedades com o Practium.',
	},
	{
		_id: '4',
		name: 'Marcos Prates',
		tipo: 'Agricultor'
	,
		status: 'inactive',
		occupation: 'Agricultor',
		testimonial: 'Experiência satisfatória no geral.',
	},
	{
		_id: '5',
		name: 'Emanuel Simão',
		tipo: 'Consultor',
		status: 'active',
		occupation: 'Consultor',
		testimonial: 'Plataforma intuitiva e completa.',
	},
	{
		_id: '6',
		name: 'Nicholas Marques',
		tipo: 'Consultor',
		status: 'active',
		occupation: 'Consultor Técnico',
		testimonial: 'Ótima ferramenta de gestão.',
	},
	{
		_id: '7',
		name: 'Viníccius Ferraz',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor',
		testimonial: '',
	},
	{
		_id: '8',
		name: 'Hugo Silva',
		tipo: 'Agricultor',
	
		status: 'active',
		occupation: 'Agricultor',
		testimonial: '',
	},
	{
		_id: '9',
		name: 'Jhonathan Maciel',
		tipo: 'Agricultor',
	
		status: 'active',
		occupation: 'Agricultor',
		testimonial: '',
	},
	{
		_id: '10',
		name: 'Jefferson Ribeiro',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor',
		testimonial: '',
	},
	{
		_id: '11',
		name: 'Guilherme Alves',
		tipo: 'Consultor',
		status: 'active',
		occupation: 'Consultor',
		testimonial: '',
	},
	{
		_id: '12',
		name: 'Lucas Ferro',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor',
		testimonial: '',
	},
	{
		_id: '13',
		name: 'Everton Silva',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor',
		testimonial: '',
	},
	{
		_id: '14',
		name: 'Wallace Abreu',
		tipo: 'Consultor',
	
		status: 'active',
		occupation: 'Consultor',
		testimonial: '',
	},
	{
		_id: '15',
		name: 'Tomas Klein',
		tipo: 'Agricultor',
		status: 'active',
		occupation: 'Agricultor',
		testimonial: '',
	},
	{
		_id: '16',
		name: 'Kevin Santos',
		tipo: 'Agricultor',
		status: 'active',
		occupation: 'Agricultor',
		testimonial: '',
	},
];

export const STATUS_OPTIONS = [
	{ value: 'yes', label: 'Sim' },
	{ value: 'no', label: 'Não' },
];

export const DEFAULT_TESTIMONIAL_FORM: TestimonialFormData = {
	name: '',
	occupation: '',
	testimonial: '',
	status: '',
};

export const LANDING_ROUTES = {
	CONTROL: '/configuracoes/landing',
	NEW_TESTIMONIAL: '/configuracoes/landing/depoimentos/novo',
	VIEW_PLAN: (id: string) => `/configuracoes/landing/planos/ver?id=${id}`,
	VIEW_TESTIMONIAL: (id: string) => `/configuracoes/landing/depoimentos/ver?id=${id}`,
} as const;

export const DEFAULT_PLAN_FORM: PlanFormData = {
	name: '',
	description: '',
	paymentMethods: [],
	hierarchy: '',
	isListable: 'yes',
	price: '',
	recurrentPayment: 'no',
	interval: 'month',
	intervalCount: '1',
	gracePeriod: '',
	notifyUnpayment: 'no',
	notifyInvoice: 'no',
	maxInstallments: '',
	maxProps: '',
	maxSamples: '',
	monthlyFloraTokens: '',
	paymentLink: '',
	advantages: [''],
};

export const MOCK_PLAN_FORM_DATA: Record<string, PlanFormData> = {
	'1': {
		name: 'Premium',
		description: 'Acesso ilimitado com suporte prioritário e relatórios avançados.',
		paymentMethods: ['credit_card', 'boleto'],
		hierarchy: 'consultant',
		isListable: 'yes',
		price: '299,90',
		recurrentPayment: 'yes',
		interval: 'month',
		intervalCount: '1',
		gracePeriod: '7',
		notifyUnpayment: 'yes',
		notifyInvoice: 'yes',
		maxInstallments: '12',
		maxProps: '50',
		maxSamples: '100',
		monthlyFloraTokens: '500',
		paymentLink: 'https://pay.practium.com.br/premium',
		advantages: ['Acesso ilimitado', 'Suporte prioritário', 'Relatórios avançados', 'Flora AI incluso'],
	},
	'2': {
		name: 'Professional',
		description: 'Acesso completo com suporte padrão e relatórios básicos.',
		paymentMethods: ['credit_card', 'boleto'],
		hierarchy: 'consultant',
		isListable: 'yes',
		price: '199,90',
		recurrentPayment: 'yes',
		interval: 'month',
		intervalCount: '1',
		gracePeriod: '7',
		notifyUnpayment: 'yes',
		notifyInvoice: 'yes',
		maxInstallments: '12',
		maxProps: '30',
		maxSamples: '60',
		monthlyFloraTokens: '300',
		paymentLink: 'https://pay.practium.com.br/professional',
		advantages: ['Acesso completo', 'Suporte padrão', 'Relatórios básicos'],
	},
	'3': {
		name: 'Basic',
		description: 'Acesso básico com suporte por e-mail.',
		paymentMethods: ['boleto'],
		hierarchy: 'manager',
		isListable: 'yes',
		price: '99,90',
		recurrentPayment: 'yes',
		interval: 'month',
		intervalCount: '1',
		gracePeriod: '5',
		notifyUnpayment: 'yes',
		notifyInvoice: 'yes',
		maxInstallments: '6',
		maxProps: '10',
		maxSamples: '20',
		monthlyFloraTokens: '100',
		paymentLink: 'https://pay.practium.com.br/basic',
		advantages: ['Acesso básico', 'Suporte por e-mail'],
	},
	'4': {
		name: 'Simple',
		description: '',
		paymentMethods: [],
		hierarchy: 'farmer',
		isListable: 'no',
		price: '',
		recurrentPayment: 'no',
		interval: 'month',
		intervalCount: '1',
		gracePeriod: '',
		notifyUnpayment: 'no',
		notifyInvoice: 'no',
		maxInstallments: '',
		maxProps: '',
		maxSamples: '',
		monthlyFloraTokens: '',
		paymentLink: '',
		advantages: [''],
	},
	'5': {
		name: 'Teste',
		description: '',
		paymentMethods: [],
		hierarchy: 'consultant',
		isListable: 'no',
		price: '',
		recurrentPayment: 'no',
		interval: 'month',
		intervalCount: '1',
		gracePeriod: '',
		notifyUnpayment: 'no',
		notifyInvoice: 'no',
		maxInstallments: '',
		maxProps: '',
		maxSamples: '',
		monthlyFloraTokens: '',
		paymentLink: '',
		advantages: [''],
	},
};
